$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
ChangeSetPasswordPopoverView = require 'app/scripts/views/member/change-set-password-popover-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class SetPasswordBannerView extends WarningBannerView
  initialize: ->
    @listenTo @model, 'change:loginTypes', =>
      @$el.toggle(!Auth.canLogIn())
      $(window).triggerHandler("resize")

  events:
    'click .js-change-password': 'changePassword'

  render: ->

    @$el.html(
      templates.fill(
        'header_warning_password',
        @model.toJSON()
      )
    )

    @

  changePassword: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-change-password')
      view: new ChangeSetPasswordPopoverView({ @model, @modelCache })
    track("Header", "Password Banner", "Open Change Password Menu")
